export default {
  properties: {
    display_name: {
      type: "string",
      description: "display name of the store ; eg : ZARA Les 4 Temps",
    },
    category: {
      type: "string",
      description:
        "Store category ; if not defined then inherits the retailer category : Eg : restaurant, boutique, cinéma",
    },
    sub_category: {
      type: "string",
      description:
        "Store sub_category ; if not defined then inherits the retailer sub category",
    },
    description: {
      type: "string",
      description:
        "Store description ; if not defined inherits the retailer description",
    },
    logo: {
      type: "string",
      description:
        "Store Logo ; if not defined then inherits the retailer logo",
      format: "binary",
      binaryEncoding: "base64",
    },
    website_uri: {
      type: "string",
      description:
        "Store website ; if not defined then inherits the retailer website uri",
    },
    phone_number: { type: "string", description: "phone" },
    location_address: { type: "string", description: "location address" },
    opening_hours: { type: "string", description: "Opening hours" },
    retailer: { type: "string", description: "Retailer" },
    mall: { type: "string", description: "Mall" },
  },
  additionalProperties: false,
  type: "object",
  title: "Store",
  description: "Store",
  required: [],
};
